import { render } from "./ModelManagement.vue?vue&type=template&id=765ba2b8&scoped=true"
import script from "./ModelManagement.vue?vue&type=script&lang=js"
export * from "./ModelManagement.vue?vue&type=script&lang=js"

import "./ModelManagement.vue?vue&type=style&index=0&id=765ba2b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765ba2b8"],['__file',"src/views/ProductManage/ModelManagement/ModelManagement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "765ba2b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('765ba2b8', __exports__)) {
    api.reload('765ba2b8', __exports__)
  }
  
  module.hot.accept("./ModelManagement.vue?vue&type=template&id=765ba2b8&scoped=true", () => {
    api.rerender('765ba2b8', render)
  })

}


export default __exports__